// H/T: https://github.com/mattdesl/lerp/blob/master/index.js
export function lerp(v0, v1, t) {
	return v0 * (1 - t) + v1 * t;
}

export function lerpArray(a0, a1, t) {
	return a0.map((v0, i) => lerp(v0, a1[i], t));
}
